import { render, staticRenderFns } from "./searchFormInTab.vue?vue&type=template&id=08e452bf&scoped=true&"
import script from "./searchFormInTab.vue?vue&type=script&lang=js&"
export * from "./searchFormInTab.vue?vue&type=script&lang=js&"
import style0 from "./searchFormInTab.vue?vue&type=style&index=0&id=08e452bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e452bf",
  null
  
)

export default component.exports